// Types
export const Types = {
    GET_EMAILS: 'GET_EMAILS',
    // GET_ALL_EMAILS: 'GET_ALL_EMAILS',
    GET_EMAIL: 'GET_EMAIL',
    UPLOAD_EMAILTEMPLATE_FILE: "UPLOAD_EMAILTEMPLATE_FILE",
    DELETE_EMAILTEMPLATE_FILE: "DELETE_EMAILTEMPLATE_FILE",
    UPDATE_EMAILS_TEMPLATE: "UPDATE_EMAILS_TEMPLATE",
    UPDATE_EMAIL_FIELDS: "UPDATE_EMAIL_FIELDS",
    DELETE_SERVER_TEMPLATE_FILE: "DELETE_SERVER_TEMPLATE_FILE",
    SET_LOADING: "SET_LOADING_EMAIL",
    DOWNLOAD_TEMPLATE_FILE: "DOWNLOAD_TEMPLATE_FILE",
  };
  
  // Reducer
  const initialState = {
    emails: null,
    // allEmails: null,
    email: null,
    emailFields: null,
    emailTemplateFile: null,
    loading: false,
  };
  
  const Emails = (state = initialState, action) => {
    switch (action.type) {
      case Types.GET_EMAILS:
        return {
          ...state,
          emails: action.payload,
          loading: false,
        }
      // case Types.GET_ALL_EMAILS:
      //   return {
      //     ...state,
      //     allEmails: action.payload,
      //     loading: false,
      //   }
      case Types.GET_EMAIL:
        return {
          ...state,
          email: action.payload,
          loading: false,
        }
      case Types.UPLOAD_EMAILTEMPLATE_FILE:
        return {
          ...state,
          emailTemplateFile: action.payload,
        }
      case Types.UPDATE_EMAILS_TEMPLATE:
        return {
          ...state,
          emailTemplateFile: action.payload,
          loading: false,
        }
      case Types.UPDATE_EMAIL_FIELDS:
        return {
          ...state,
          emailFields: action.payload,
          loading: false,
        }
      case Types.DELETE_EMAILTEMPLATE_FILE:
        return {
          ...state,
          emailTemplateFile: null,
          loading: false,
        }
      case Types.DELETE_SERVER_TEMPLATE_FILE:
        return {
          ...state,
          emailTemplateFile: null,
          loading: false,
        }
      case Types.DOWNLOAD_TEMPLATE_FILE:
        return {
          ...state,
          emailTemplateFile: action.payload,
          loading: false,
        }
      case Types.SET_LOADING:
        return {
          ...state,
          loading: true,
        }
      default: return state;
    }
  };
  
  export default Emails;